import React from 'react';
import { getOfflineActionLabel, getOfflineActionMeta } from './offlineQueueUtils';
import ModalShell from '../../ui/ModalShell';

function OfflineQueueModal({
  isOpen,
  entries,
  isOnline,
  offlineSyncing,
  onClose,
  onFlush,
  onClear,
  formatDateTime,
  getCurrentTimeZone
}) {
  if (!isOpen) return null;

  return (
    <ModalShell onClose={onClose}>
      <h3>Offline Sync Queue</h3>
      <p className="modal-text">
        {entries.length === 0
          ? 'No pending actions. New offline actions will appear here.'
          : `${entries.length} action${entries.length === 1 ? '' : 's'} pending sync.`}
      </p>
      {entries.length === 0 ? (
        <div className="empty-state">Queue is empty.</div>
      ) : (
        <div className="table-wrapper">
          <table className="data-table">
            <thead>
              <tr>
                <th>Action</th>
                <th>Details</th>
                <th>Queued At</th>
              </tr>
            </thead>
            <tbody>
              {entries.map((entry) => (
                <tr key={entry.id}>
                  <td>{getOfflineActionLabel(entry.type)}</td>
                  <td>{getOfflineActionMeta(entry) || '-'}</td>
                  <td>{formatDateTime(entry.queued_at, getCurrentTimeZone())}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <div className="modal-actions">
        <button type="button" onClick={onClose}>Close</button>
        {isOnline && entries.length > 0 && (
          <button type="button" className="btn-edit" onClick={onFlush} disabled={offlineSyncing}>
            {offlineSyncing ? 'Syncing...' : 'Sync Now'}
          </button>
        )}
        {entries.length > 0 && (
          <button type="button" className="btn-delete" onClick={onClear} disabled={offlineSyncing}>
            Clear Queue
          </button>
        )}
      </div>
    </ModalShell>
  );
}

export default OfflineQueueModal;
